import {defineMessages, FormattedMessage} from 'react-intl';
import {Button, view} from '@sail/ui';
import {useCallback} from 'react';
import {TopBar} from '../TopBar';
import {SpeakerButton} from './SpeakerButton';
import {useWidgetControls} from '../../useWidget';

const messages = defineMessages({
  chattingWithName: {
    id: 'conversations_ui.widget.liveChatTopBar.chattingWithName',
    description:
      'Text indicating name of support agent the user is chatting with',
    defaultMessage: 'Chatting with {name}',
  },
  connectingWithAgent: {
    id: 'conversations_ui.widget.liveChatTopBar.chattingWithGeneric',
    description: 'Text indicating who the user is chatting stripe support',
    defaultMessage: 'Connecting with agent',
  },
  endChatButton: {
    id: 'conversations_ui.widget.liveChatTopBar.endChatButton',
    description: 'Button to end conversation with an agent',
    defaultMessage: 'End chat',
  },
});

type Props = {
  agentNames: string[];
};

const Title = ({agentNames}: {agentNames: string[]}) => (
  <view.div css={{font: 'label.small.emphasized'}}>
    {agentNames.length > 0 ? (
      <FormattedMessage
        {...messages.chattingWithName}
        values={{name: agentNames.join(', ')}}
      />
    ) : (
      <FormattedMessage {...messages.connectingWithAgent} />
    )}
  </view.div>
);

const Controls = ({onClose}: {onClose: () => void}) => (
  <view.div css={{stack: 'x', alignX: 'end'}}>
    <SpeakerButton />
    <Button
      size="small"
      onPress={onClose}
      data-testid="conversations-widget-end-chat-button"
    >
      <FormattedMessage {...messages.endChatButton} />
    </Button>
  </view.div>
);

export const LiveChatTopBar = ({agentNames}: Props) => {
  const {close} = useWidgetControls();

  const onClose = useCallback(() => {
    close(false);
  }, [close]);

  return (
    <TopBar data-testId="widget-topbar-live-chat">
      <view.div css={{stack: 'x'}}>
        <Title agentNames={agentNames} />
        <Controls onClose={onClose} />
      </view.div>
    </TopBar>
  );
};
